import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
export function App() {
  return <AuthProvider data-id="element-0">
      <DataProvider data-id="element-1">
        <Router data-id="element-2">
          <Toaster position="top-right" data-id="element-3" />
          <Routes data-id="element-4">
            <Route path="/login" element={<Login data-id="element-6" />} data-id="element-5" />
            <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-8" />} data-id="element-7" />
            <Route path="/dashboard/*" element={<ProtectedRoute data-id="element-10">
                  <Layout data-id="element-11">
                    <Dashboard data-id="element-12" />
                  </Layout>
                </ProtectedRoute>} data-id="element-9" />
          </Routes>
        </Router>
      </DataProvider>
    </AuthProvider>;
}